function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@babel_runtime@7.7.2@@babel/runtime/helpers/inheritsLoose.js
// module id = 8
// module chunks = 0 1 2